export const includedKeyword = (keyword: string): boolean =>
  !/(sex worker)|(graduate)/i.test(keyword);
